import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './HorizontalSlider.scss';

interface CardContent {
    title: string | GenericLazyString;
    imageUrl: string;
    style?: 'horizontal' | 'vertical';
    imageLoading?: 'eager' | 'lazy';
}
export const HorizontalSliderCard: React.FunctionComponent<CardContent> = ({
    title,
    imageUrl,
    style = 'Vertical',
    imageLoading = 'eager',
}) => {
    return (
        <div className={`sliderCard sliderCard${style}`}>
            <div className="sliderCardImageWrapper">
                <img
                    src={imageUrl}
                    alt={title?.toString()}
                    loading={imageLoading}
                />
            </div>
            <p className="sliderCardTitle eds-text-weight--heavy">{title}</p>
        </div>
    );
};
